module.exports = __webpack_public_path__ + "img/logo-rexon.70455ac0.svg";